import { render } from "./NewsView.vue?vue&type=template&id=5f701122&scoped=true&ts=true"
import script from "./NewsView.vue?vue&type=script&lang=ts"
export * from "./NewsView.vue?vue&type=script&lang=ts"

import "./NewsView.vue?vue&type=style&index=0&id=5f701122&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f701122"]])

export default __exports__